import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import {
    initialPatientFusionModalState,
    PatientFusionModalState
} from '@/modules/RegistryModule/views/editCase/modals/patient-fusion/modal/patient-fusion-modal.model'
import { BModal } from 'bootstrap-vue'
import PatientFusionDataComponent from '@/modules/RegistryModule/views/editCase/modals/patient-fusion/data/patient-fusion-data.vue'
import PatientFusionData from '@/modules/RegistryModule/views/editCase/modals/patient-fusion/data/patient-fusion-data'
import ModalConfirmation from '@/components/modals/ModalConfirmation.vue'
import PatientIdentifierResource from '@/api/resources/PatientIdentifierResource'
import CenterResource from '@/api/resources/common/commonCenterService'
import patientResource from '@/api/resources/PatientResource'
import patientServices from '@/modules/RegistryModule/services/patientServices'
import { PromiseUtils } from '@/shared/util/promise-utils'
import { ModalUtils } from '@/shared/util/modal-utils'
import { StrictNullable } from '@/shared/types/app.types'
import { PatientSearchResponse } from '@/api/services/patient/patient/patient.dto'

@Component({
    components: {
        PatientFusionDataComponent,
        ModalConfirmation
    }
})
export default class PatientFusionModal extends Vue {
    @Prop({ type: Number }) readonly casPatId!: number

    @Ref() readonly patientFusionModal!: BModal
    @Ref() readonly patientFusionDataMaintain!: PatientFusionData
    @Ref() readonly patientFusionDataDelete!: PatientFusionData
    @Ref() readonly modalConfirmation!: any

    state: PatientFusionModalState
    constructor() {
        super()
        this.state = initialPatientFusionModalState()
    }

    // PatientWithAllIdsResponse
    private static async _getPatientById(patientId?: number): Promise<StrictNullable<any>> {
        return patientId
            ? PromiseUtils.toCallSecure(patientResource.findById(patientId))
            : null
    }

    private async _loadIdentifierTypes(): Promise<void> {
        const response = await PromiseUtils.toCallSecure(PatientIdentifierResource.index())
        this.state.identifierTypes = response ?? []
    }
    private async _loadCenters(): Promise<void> {
        const response = await PromiseUtils.toCallSecure(CenterResource.getActiveCenters())
        this.state.centers = response ?? []
    }
    async show(patientToMaintainId?: number, patientToDeleteId?: number): Promise<void> {
        this.state.patientToMaintain = await PatientFusionModal._getPatientById(patientToMaintainId)
        this.state.patientToDelete = await PatientFusionModal._getPatientById(patientToDeleteId)

        await Promise.all([
            this._loadIdentifierTypes(),
            this._loadCenters()
        ])
        this.patientFusionModal.show()
    }
    onShow(): void {
        this.patientFusionDataMaintain.focus()
    }
    hide(): void {
        this.patientFusionModal.hide()
    }

    async onPatientToMaintainChanged(patient: PatientSearchResponse): Promise<void> {
        this.patientFusionDataDelete.focus()
        this.state.patientToMaintain = await PatientFusionModal._getPatientById(patient.patId)
    }
    async onPatientToDeleteChanged(patient: PatientSearchResponse): Promise<void> {
        this.patientFusionDataMaintain.focus()
        this.state.patientToDelete = await PatientFusionModal._getPatientById(patient.patId)
    }

    changePatients(patientToDelete: PatientSearchResponse, patientToMaintain: PatientSearchResponse): void {
        this.state.patientToDelete = patientToMaintain
        this.state.patientToMaintain = patientToDelete
    }
    mergePatients(): void {
        if (!!this.state.patientToMaintain && !!this.state.patientToDelete) {
            if (this.state.patientToMaintain.patId === this.state.patientToDelete.patId) {
                ModalUtils.showErrorModal(this.$tc('registry.modal.samePatientMerge'))
                return
            }

            this.modalConfirmation.ask(async () => {
                if (!!this.state.patientToMaintain && !!this.state.patientToDelete) {
                    const response =
                        await PromiseUtils.toCallSecure(
                            patientServices.mergePatients(
                                this.state.patientToMaintain.patId,
                                this.state.patientToDelete.patId))
                    if (response !== null) {
                        if (this.casPatId === this.state.patientToDelete.patId) {
                            this.$emit('updateCase')
                        }
                        this.$emit('patientsMerged')
                        ModalUtils.showSuccessModal(this.$tc('registry.cases.mergedPatient'))
                        this.hide()
                    }
                }
            })
        }
    }
}
